import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  holder: {
    display: 'flex',
    alignItems: 'center',
    flex: '1',
    padding: '0.5rem 0px',
    '&:not(:last-child)': {
      borderBottom: 'solid 1px lightgrey'
    }
  },

  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '4px',
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    padding: '0.25rem 0px',

    cursor: ({ disableInteract }) => (disableInteract ? 'default' : 'pointer'),

    [theme.breakpoints.down(340)]: {
      width: 'calc(100% - 1.5rem)'
    }
  },

  activeConvo: {
    color: `${theme.palette.primary.main} !important`,

    '& strong': {
      color: `${theme.palette.primary.main} !important`
    }
  },

  convoTitle: {
    display: 'flex',
    alignItems: 'center',
    color: '#8F8F8F',

    '& svg': {
      marginRight: '4px',
      flexShrink: '0'
    },

    '& strong': {
      margin: '0px 4px'
    }
  },

  content: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },

  name: {
    margin: '0 11px',
    width: '100%',
    fontSize: theme.size.sm,
    color: '#7F8487',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },

  ellipsisText: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  }
}))

export default useStyles
